import { getError } from "@/utils/get-error";
import { axiosInstance } from "@dexteel/mesf-core";
import { Axios } from "axios";

export class RootTypeRepository {
	private axios: Axios;
	constructor() {
		this.axios = axiosInstance;

		this.getRootTypes = this.getRootTypes.bind(this);
		this.getRootTypeById = this.getRootTypeById.bind(this);
	}

	async getRootTypes() {
		try {
			const rootTypes = await this.axios.get("/RootType/");

			return {
				ok: true,
				rootTypes: rootTypes.data,
			};
		} catch (error: any) {
			const message = getError(error);
			return Promise.reject(message);
		}
	}

	async getRootTypeById(rootTypeId: number | null) {
		try {
			const rootType = await this.axios.get(`/RootType/${rootTypeId}`);
			return {
				ok: true,
				rootType: rootType.data,
			};
		} catch (error) {
			return {
				ok: false,
				error,
			};
		}
	}
}

export const { getRootTypes, getRootTypeById } = new RootTypeRepository();
